<div class="grid grid-rows-[auto_1fr_auto] h-full">
  <!-- Header with subject information -->
  @if (!this.isServizi) {
    <div>
      <app-generic-info-user
        [attivitaInfo]="utenzaInfoData()"
        [titleComponent]="titleComponent()"
        [loading]="loadingUtenza()"
      >
      </app-generic-info-user>
    </div>
  } @else {
    <div class="title">{{ titleComponent() }}</div>
  }

  <!-- Main content area -->
  <div class="flex-1 overflow-auto">
    <!-- Add bottom padding for fixed navigation -->
    <!-- Progress indicator -->
    <app-wizard-navigation
      [steps]="availableSteps()"
      [currentStepIndex]="currentStepIndex()"
      [canGoBack]="canGoBack()"
      [canGoNext]="canGoNext()"
      [isLastStep]="isLastStep()"
      (stepClick)="goToStep($event)"
      (previous)="previousStep()"
      (next)="nextStep()"
      (save)="saveWizardDataWithValidation()"
      (cancel)="cancelWizard()"
    >
      <!-- Step content proiettato  -->
      <div #steppers class="step-content-container">
        @if (currentStep(); as step) {
          <div class="step-content">
            <!-- Dynamic step component container -->
            <div class="bg-white">
              <!-- Dynamic component will be loaded here -->
              <ng-container #stepContainer></ng-container>
            </div>
          </div>
        } @else {
          <div class="text-center py-8">
            <p class="text-gray-500">
              {{ "WIZARD.MESSAGES.NO_STEP_SELECTED" | translate }}
            </p>
          </div>
        }
      </div>
    </app-wizard-navigation>

    <!-- Loading state -->
    @if (isLoading()) {
      <div class="fixed inset-0 black-bg flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-lg">
          <p>{{ "WIZARD.MESSAGES.LOADING" | translate }}</p>
        </div>
      </div>
    }

    <!-- Toast messages for validation feedback -->
    <!-- <p-toast position="top-right" [life]="5000"></p-toast> -->

    <!-- Error messages -->
    @if (errors().length > 0) {
      <div class="fixed top-4 right-4 z-50">
        @for (error of errors(); track $index) {
          <div
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-2"
          >
            {{ error }}
          </div>
        }
      </div>
    }
  </div>
</div>

<p-confirmDialog />

<p-confirmdialog
  key="success"
  [title]="titleDialog()"
  [closable]="false"
  [style]="{ width: '30rem', maxWidth: '90vw' }"
  class="success-dialog"
>
  <ng-template #message let-message>
    <div
      class="flex flex-col items-center w-full gap-4 border-surface-200 dark:border-surface-700"
    >
      <i
        class="text-6xl! text-primary-500 pi pi-check-circle color-primary"
      ></i>
      <p class="text-xl! font-semibold mb-3">{{ message.message }}</p>
      @if (!isAttivita) {
        <div
          class="w-full lg:w-[90%] bg-[#E9F7F8] rounded px-4 py-3 flex items-center gap-3"
        >
          <i class="pi pi-ticket text-primary-500"></i>
          <span class="font-medium"
            ><b>{{ isServizi ? 'Codice' : 'ID ' + titleDialog() }}:</b> {{ createdId() }}</span
          >
        </div>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="w-full flex justify-center mt-3">
      <p-button
        [label]="labelDialog()"
        class="w-full lg:w-[90%]"
        (onClick)="navigateBack(true)"
      >
      </p-button>
    </div>
  </ng-template>
</p-confirmdialog>
